import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const GoogleGlobalIntelligenceGate = React.lazy(
  () => import("./GoogleGlobalIntelligence.gate")
);

const GoogleGlobalIntelligenceLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <GoogleGlobalIntelligenceGate />
  </React.Suspense>
);

export default () => <GoogleGlobalIntelligenceLoadable />;
